import { PageHeader } from 'components/layout/Page';
import React, { FunctionComponent, useState } from 'react';
import moment from 'moment';
import { Criteria, EuiBasicTable } from '@elastic/eui';
import { useCreateAuditingQuery, useGetAuditingQuery } from 'components/connections/connectionsApi';
export default function Auditing() {
  return (
    <>
      <PageHeader showBack={true} title="Log"></PageHeader>
      <RecordTable />
    </>
  );
}

const RecordTable: FunctionComponent = () => {
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageIndex: 0,
    offset: 0,
    totalItemCount: 100,
    pageSizeOptions: [10, 50],
    showPerPageOptions: true,
  });

  const updatePagination = (field: string, value: any) => {
    setPagination((pagination) => ({ ...pagination, [field]: value }));
  };
  const { isLoading: queryIdIsLoading, data: queryIdResult } = useCreateAuditingQuery();

  const id = queryIdResult;
  const { offset, pageSize } = pagination;

  // Only fetch if we have an ID
  const { isLoading: queryResultIsLoading, data: queryResults } = useGetAuditingQuery(
    id,
    offset,
    pageSize,
    {
      enabled: !!id, // prevents fetching until id is available
    }
  );
  const onTableChange = ({ page }: Criteria<Record>) => {
    if (page) {
      const { index: pageIndex, size: pageSize } = page;
      updatePagination('pageIndex', pageIndex);
      updatePagination('pageSize', pageSize);
    }
  };

  const columns = [
    {
      field: 'connection.id',
      name: 'Connection ID',
    },
    {
      field: 'changeType',
      name: 'Change Type',
      render: (changeType: Record['changeType']): string => {
        return changeTypeMap[changeType] || 'Not Supported';
      },
    },
    {
      field: 'identifier',
      name: 'Identifier',
    },
    {
      field: 'dateTime',
      name: 'Date and time',
      render: (dateTime: Record['dateTime']) => moment(dateTime).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      field: 'userId',
      name: 'User ID',
    },
  ];

  return (
    <EuiBasicTable
      items={queryResults ? queryResults.records : []}
      columns={columns}
      pagination={pagination}
      onChange={onTableChange}
      loading={!queryResults || queryIdIsLoading || queryResultIsLoading}
    />
  );
};
const changeTypeMap: any = {
  'urn:flux:auditing:changeType:rating:plan:update': 'Update plans',
  'urn:flux:auditing:changeType:rating:plan:add': 'Create plan',
  'urn:flux:auditing:changeType:rating:plan:state:update': 'Change plan state',
  'urn:flux:auditing:changeType:rating:plan:charge:add': 'Create charges',
  'urn:flux:auditing:changeType:rating:plan:charge:charge-id:update': 'Update charges',
  'urn:flux:auditing:changeType:rating:plan:charge:charge-id:delete': 'Delete charges',
  'urn:flux:auditing:changeType:rating:provider:add': 'Add providers',
  'urn:flux:auditing:changeType:rating:provider:update': 'Update providers',
  'urn:flux:auditing:changeType:rating:qualifier:add': 'Add qualifiers',
  'urn:flux:auditing:changeType:rating:qualifier:update': 'Update qualifers',
  'urn:flux:auditing:changeType:rating:summarisation-groups:add': 'Add summarisation groups',
  'urn:flux:auditing:changeType:rating:connection:add': 'Add Connections',
  'urn:flux:auditing:changeType:rating:connection:update': 'Updating connection',
  'urn:flux:auditing:changeType:rating:connection:supply-period:add': 'Add supply period',
  'urn:flux:auditing:changeType:rating:connection:supply-period:supply-period:update':
    'Updating supply period id',
  'urn:flux:auditing:changeType:rating:connection:supply-period:plan-link:add': 'Add plan link',
  'urn:flux:auditing:changeType:rating:connection:supply-period:plan-link:plan-links:update':
    'Updating plan link',
  'urn:flux:auditing:changeType:rating:connection:supply-period:plan-link-plan-link:delete':
    'Deleting plan link',
  'urn:flux:auditing:changeType:billing:invoices:update': 'Update invoices',
  'urn:flux:auditing:changeType:billing:invoices:add': 'Create invoice',
  'urn:flux:auditing:changeType:ratings:add': 'Requests for rating information',
};

interface Record {
  changeType: string;
  userId: string;
  dateTime: string;
  connection: { [id: string]: string };
  identifier: string;
}
